<p-table stripedRows #dataTable
    [value]="documentation"
    dataKey="id"
    rowHover="true"
    editMode="row"
    sortField="EmployeeWorkDate"
    [scrollable]="true"
    scrollHeight="75vh"
    [sortOrder]="1"
    [responsive]="false"
    [style]="{ 'min-width': '50em' }"
    styleClass="timecard-doc-table"
    [resizableColumns]="false"
>
    <ng-template pTemplate="colgroup">
        <colgroup>
            <col class="edit-cell" />
            <col class="status-cell" />
            <col />
            <col class="work-date-cell" />
            <col class="time-doc-hours-cell" />
            <col class="doc-hours-cell" />
            <col />
            <col />
            <col *ngIf="includeClassify" />
            <col />
            <col class="delete-cell" />
        </colgroup>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="9" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>

    <ng-template #header>
        <tr>
            <!-- Edit -->
            <th class="edit-cell"></th>
            <!-- Status -->
            <th class="status-cell">
                <i
                    class="pi pi-exclamation-circle"
                    title="Status"
                ></i>
            </th>
            <!-- Task -->
            <th pSortableColumn="TaskLongName">
                Task
                <p-sortIcon
                    field="TaskLongName"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="TaskLongName" display="menu" class="ml-auto" />
            </th>
            <!-- Work Date -->
            <th
                pSortableColumn="EmployeeWorkDate"
                class="work-date-cell"
            >
                Work Date
                <p-sortIcon
                    field="EmployeeWorkDate"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="EmployeeWorkDate" display="menu" class="ml-auto" />
            </th>
            <!-- Hours -->
            <th
                pSortableColumn="EmpTimeIDHours"
                class="time-doc-hours-cell"
            >
                Hours
            </th>
            <!-- Doc Hours -->
            <th class="doc-hours-cell">
                Doc Hours
            </th>
            <!-- Text Documentation -->
            <th pSortableColumn="TimeDocText">
                Text Documentation
                <p-sortIcon
                    field="TimeDocText"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="TimeDocText" display="menu" class="ml-auto" />
            </th>
            <!-- Add'l Doc -->
            <th>
                Add'l Doc
            </th>
            <!-- Class -->
            <th

                [hidden]="!includeClassify"
                *ngIf="includeClassify"
            >
                Class
            </th>
            <!-- Attachment -->
            <th>
                <i
                    class="pi pi-paperclip"
                    style="transform: rotate(-45deg); color: white"
                ></i
                >&nbsp;Attachments
            </th>
            <!-- Delete -->
            <th class="delete-cell"></th>
        </tr>
    </ng-template>
    <ng-template #body let-doc let-edit="editing" let-ri="rowIndex">
        <tr
            [pEditableRow]="doc"
            data-id="row-{{ doc.id }}"
            [pEditableRowDisabled]="doc.IsReadOnly"
            [ngClass]="{
                'ui-editing-row': edit && editing?.id === doc?.id
            }"
        >
            <!-- Edit -->
            <td class="edit-cell">

                    <button
                        *ngIf="
                            (doc.IsReadOnly == false || doc.IsReadOnly == null) && !edit && (!editing?.id || editing?.id === doc?.id)
                        "
                        pButton
                        type="button"
                        pInitEditableRow
                        icon="pi pi-pencil"
                        class="p-button-rounded p-button-text"
                        (click)="onRowEditInit(doc)"
                        title="Edit"
                    ></button>
                    <button
                        *ngIf="edit"
                        pButton
                        type="button"
                        pSaveEditableRow
                        icon="pi pi-check"
                        class="p-button-rounded p-button-text p-button-success"
                        [disabled]="timecardDoc.invalid"
                        (click)="onRowEditSave(doc)"
                    ></button>
                    <button
                        *ngIf="edit"
                        pButton
                        type="button"
                        pCancelEditableRow
                        icon="pi pi-times"
                        class="p-button-rounded p-button-text p-button-danger"
                        (click)="onRowEditCancel(doc)"
                    ></button>
            </td>
            <!-- Status -->
            <td class="status-cell">
                <div (click)="onStatusClick(doc)" class="status-cell">
                    <ef-status-icon
                        [status]="doc?.Status?.StatusCode"
                        [message]="doc?.Status?.Message"
                    ></ef-status-icon>
                </div>
            </td>
            <!-- Task -->
            <td
                class="disabled"
                [title]="doc?.TaskLongName"
            >
                {{ doc?.TaskLongName ? doc?.TaskLongName : '&nbsp;' }}
            </td>
            <!-- Work Date -->
            <td
                class="disabled work-date-cell"
            >
                <div [title]="doc?.EmployeeWorkDate | date: 'MM/dd/yyyy'">
                    {{
                        doc?.EmployeeWorkDate
                            ? (doc?.EmployeeWorkDate | date: 'MM/dd/yyyy')
                            : '&nbsp;'
                    }}
                </div>
            </td>
            <!-- Hours -->
            <td
                class="disabled time-doc-hours-cell"
            >
                <div [title]="doc?.EmpTimeIDHours">
                    {{ doc.EmpTimeIDHours }}
                </div>
            </td>
            <!-- Doc Hours -->
            <td
                class="doc-hours-cell"
                [ngClass]="{
                    'tiny-cell': true,
                    disabled: doc.IsReadOnly
                }"
                #docHours
            >
                <p-cellEditor>
                    <ng-template *ngIf="!doc.IsReadOnly" pTemplate="input">
                        <div>
                            <ng-form [formGroup]="timecardDoc">
                                <input
                                    pInputText
                                    type="text"
                                    formControlName="hours"
                                    [(ngModel)]="updatedDocHours"
                                    [title]="
                                        timecardDoc?.controls['hours']?.errors
                                            ?.max
                                            ? timecardDoc?.controls['hours']
                                                  ?.errors?.max?.max +
                                              ' hours available for documentation'
                                            : ''
                                    "
                                />
                            </ng-form>
                        </div>
                    </ng-template>
                    <ng-template *ngIf="doc.IsReadOnly" pTemplate="input">
                        <div [title]="doc?.Hours">
                            {{ doc?.Hours }}
                        </div>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <div [title]="doc?.Hours">
                            {{ doc?.Hours }}
                        </div>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Text Documentation -->
            <td
                [ngClass]="{
                    'large-cell': true,
                    disabled: doc.IsReadOnly
                }"
            >
                <p-cellEditor>
                    <ng-template *ngIf="!doc.IsReadOnly" pTemplate="input">
                        <input
                            pInputText
                            type="text"
                            [(ngModel)]="timeDocText"
                            id="focusOnMe"
                        />
                    </ng-template>
                    <ng-template *ngIf="doc.IsReadOnly" pTemplate="input">
                        <div
                            [title]="doc?.TimeDocText"
                            class="text-nowrap-ellipsis"
                        >
                            {{ doc.TimeDocText }}
                        </div>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <div
                            [title]="doc?.TimeDocText"
                            class="text-nowrap-ellipsis"
                        >
                            {{ doc.TimeDocText }}
                        </div>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Add'l Doc -->
            <td
                [ngClass]="{
                    'small-cell': true,
                    disabled:
                        doc.IsReadOnly ||
                        (this.documentation
                            | filter: 'EmpTimeID':doc.EmpTimeID
                            | reducemax
                                : '(a,c) => a+c.Hours'
                                : doc.EmpTimeIDHours)
                }"
            >
                <div>
                    <span *ngIf="!doc.IsReadOnly">
                        <a
                            *ngIf="
                                !(
                                    this.documentation
                                    | filter: 'EmpTimeID':doc.EmpTimeID
                                    | reducemax
                                        : '(a,c) => a+c.Hours'
                                        : doc.EmpTimeIDHours
                                ) &&
                                doc.WorkID > 0 &&
                                !editing
                            "
                            href="#"
                            (click)="addNewDoc($event, doc)"
                            >Add'l Doc</a
                        >
                    </span>
                </div>
            </td>
            <!-- Class -->
            <td
                [ngClass]="{
                    'small-cell': true,
                    disabled: doc.IsReadOnly
                }"
                [hidden]="!includeClassify"
                *ngIf="includeClassify"
            >
                <p-cellEditor>
                    <ng-template *ngIf="!doc.IsReadOnly" pTemplate="input">
                        <div>
                            <p-dropdown
                                [virtualScroll]="true"
                                itemSize="32"
                                [(ngModel)]="doc.ClassListID"
                                [options]="
                                    ClassesForAuth.asObservable() | async
                                "
                                [filter]="true"
                                placeholder="Class"
                                appendTo="body"
                                [style]="{
                                    height: '100%',
                                    'min-height': '21px'
                                }"
                            ></p-dropdown>
                        </div>
                    </ng-template>
                    <ng-template *ngIf="doc.IsReadOnly" pTemplate="input">
                        <div
                            [title]="doc?.ClassListID | classlist: this.Classes"
                        >
                            {{ doc?.ClassListID | classlist: this.Classes }}
                        </div>
                    </ng-template>

                    <ng-template pTemplate="output">
                        <div
                            [title]="doc?.ClassListID | classlist: this.Classes"
                        >
                            {{ doc?.ClassListID | classlist: this.Classes }}
                        </div>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Attachment -->
            <td
                [ngClass]="{
                    'small-cell': true,
                    disabled: doc.IsReadOnly
                }"
            >
                <p-cellEditor>
                    <ng-template
                        *ngIf="!doc.IsReadOnly && !doc.File_unique_id"
                        pTemplate="input"
                    >
                        <p-fileUpload
                            [accept]="acceptedFiles"
                            [title]=""
                            method="PUT"
                            [url]="environment.apiLocation + '/Attachment'"
                            name="File"
                            mode="basic"
                            customUpload="true"
                            chooseIcon="pi pi-upload"
                            [disabled]="timecardDoc.invalid || doc.IsReadOnly"
                            [auto]="true"
                            (uploadHandler)="onAttachmentUpload($event)"
                            (onSelect)="onAttachmentSelect($event)"
                            (onError)="onUploadError($event)"
                            #timecardAttachmentUploader
                            invalidFileSizeMessageSummary=""
                            invalidFileSizeMessageDetail=""
                            invalidFileTypeMessageSummary="Invalid file type"
                            invalidFileLimitMessageDetail=""
                            invalidFileLimitMessageSummary=""
                            invalidFileTypeMessageDetail=""
                        ></p-fileUpload>
                    </ng-template>
                    <ng-template *ngIf="doc.File_unique_id" pTemplate="input">
                        <div *ngIf="!editing">
                            <a
                                *ngIf="doc.File_unique_id"
                                target="_blank"
                                [href]="
                                    this.ss.href('attachment', {
                                        fileId: doc.File_unique_id
                                    })
                                "
                                >View</a
                            >
                            &nbsp;
                            <pre>IsReadOnly: {{ doc.IsReadOnly }}</pre>
                            <a
                                *ngIf="doc.File_unique_id && !doc.IsReadOnly"
                                href="#"
                                (click)="
                                    onAttachmentDelete(
                                        $event,
                                        doc.File_unique_id
                                    )
                                "
                                >Delete</a
                            >
                        </div>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <div *ngIf="!editing">
                            <a
                                *ngIf="doc.File_unique_id"
                                target="_blank"
                                rel="noopener"
                                [href]="
                                    this.ss.href('attachment', {
                                        fileId: doc.File_unique_id
                                    })
                                "
                                >View</a
                            >
                            &nbsp;
                            <a
                                *ngIf="doc.File_unique_id && !doc.IsReadOnly"
                                target="_blank"
                                rel="noopener"
                                href="#"
                                (click)="
                                    onAttachmentDelete(
                                        $event,
                                        doc.File_unique_id
                                    )
                                "
                                >Delete</a
                            >
                        </div>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Delete -->
            <td
                [ngClass]="{
                    'delete-cell': true,
                    disabled: doc.IsReadOnly
                }"
            >
                <div>
                    <span *ngIf="!doc.IsReadOnly && doc.WorkID > 0 && !editing">
                        <button
                            pButton
                            type="button"
                            icon="pi pi-trash"
                            class="ef-button-danger ef-circle-button"
                            (click)="onRowDelete($event, doc)"
                            style="font-size: 1em"
                        ></button>
                    </span>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>
